import type { IconProps } from "./icon-types";

/**
 * 좌표 입력. 중앙 point와 네 방향의 축 tick으로 frame 안의 정확한 위치 지정을 나타낸다.
 *
 * annotation marker와 혼동되지 않도록 point 자체는 비워 두고, 작은 IconButton에서도 중심이
 * 흔들리지 않도록 24 grid의 양축 대칭 stroke로 구성한다.
 */
export const CoordinateIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <circle cx="12" cy="12" r="3" />
    <path d="M12 3v4M12 17v4M3 12h4M17 12h4" />
  </svg>
);
